var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "settings-component mb-5" }, [
    !_vm.loader
      ? _c(
          "div",
          [
            _c("h1", [_vm._v(_vm._s(_vm.$l10n.__("Réglages")))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-row setting-nav jc-center semibold fs-14" },
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "settings.home.general" } } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex-row ai-center",
                        class: { selected: _vm.state === "settings" }
                      },
                      [
                        _c("span", { staticClass: "lh-20" }, [
                          _vm._v(_vm._s(_vm.$l10n.__("Général")))
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "settings.home.internal"
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex-row ai-center",
                        class: { selected: _vm.state === "plugins" }
                      },
                      [
                        _c("span", { staticClass: "lh-20" }, [
                          _vm._v(_vm._s(_vm.$l10n.__("Module Sellsy")))
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "settings.home.external"
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex-row ai-center",
                        class: { selected: _vm.state === "externals" }
                      },
                      [
                        _c("span", { staticClass: "lh-20" }, [
                          _vm._v(_vm._s(_vm.$l10n.__("Module Externe")))
                        ])
                      ]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("router-view")
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "prelative" },
          [_c("preloader", { attrs: { display: _vm.loader } })],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }